"use client";

import { useAtom } from "jotai";
import shuffle from "lodash/shuffle";
import { selectedObservatoryAtom } from "@/store/sites";
import type { Observatory, ThemeTypeEnum } from "@/types";

function useObservatories(observatories: Observatory[]) {
  const _observatories = observatories;

  const [selectedObservatory, setSelectedObservatory] = useAtom(
    selectedObservatoryAtom,
  );

  const findObservatoryById = (
    id: string,
    observatories?: Observatory[],
  ): Observatory | null => {
    const data = observatories ?? _observatories;
    return data.find((item) => item.id === id) || null;
  };

  const shuffleObservatories = (
    observatories?: Observatory[],
  ): Observatory[] => {
    const data = observatories ?? _observatories;
    return shuffle(data);
  };

  const filterObservatoriesByThemes = (
    themes: ThemeTypeEnum[],
    observatories?: Observatory[],
  ): Observatory[] => {
    const data = observatories ?? _observatories;
    return data.filter((observatory) =>
      themes.includes(observatory.theme as ThemeTypeEnum),
    );
  };

  const sortObservatoriesAlphabetically = (
    locale: string,
    observatories?: Observatory[],
  ): Observatory[] => {
    const data = observatories ?? _observatories;
    return data.sort((a, b) => {
      return a.name[locale]
        .toLowerCase()
        .localeCompare(b.name[locale].toLowerCase(), locale, {
          sensitivity: "base",
        });
    });
  };

  return {
    observatories,
    selectedObservatory,
    setSelectedObservatory,
    findObservatoryById,
    shuffleObservatories,
    filterObservatoriesByThemes,
    sortObservatoriesAlphabetically,
  };
}

export { useObservatories };
